import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ReactTooltip from "react-tooltip";
import { useEffect, useState } from "react";
import { Box, IconButton, InputBase, Tooltip, Typography, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { tokens } from "../theme";
import { addToMiscCartItems, updateCartItem } from "../features/cart/cartSlice";
import { generatedUniqueId, generateUniqueId } from "./utils";


export const COLUMN_NAME = "Column";
export const ARM_NAME = "Arm";
export const BASE_NAME = "Base";
export const BRACE_NAME = "Bracing";

const CustomQuotationCartItem = (props) => {
  const [customItemName, setCustomItemName] = useState('');
  const [customItemDescription, setCustomItemDescription] = useState('');
  const [customItemId, setCustomItemId] = useState(generateUniqueId());
  const [customItemPrice, setCustomItemPrice] = useState(0);
  const [customItemFinish, setCustomItemFinish] = useState('');
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [totalQuantity, setTotalQuantity] = useState(0);
//   const [subTotalPrice, setSubTotalPrice] = useState(0);


    const addToCart = () => {
        const item = {
            id: generatedUniqueId(),
            part: {
                name: customItemName,
                description: customItemDescription,
                finish: customItemFinish,
                price: customItemPrice,
                custom: true
            },
            quantity: totalQuantity,
            price: subtotalPrice,
            section: props.section,
        }
        dispatch(addToMiscCartItems(item));
    }

  const dispatch = useDispatch();

  const handleQuantity = (v) => {
    setTotalQuantity(v);
    addToCart()
  };

  const subtotalPrice = totalQuantity * customItemPrice;

  return (
    <>
      {(
        <Box width="100%">
          <Box display="flex" alignItems="center" mx="0.5em">
            <div className="d-flex flex-column flex-start">
              <div className="d-flex">
              <div className="d-flex flex-column mx-2">
                <Typography>Name</Typography>
                <InputBase
                  data-tip
                  data-for="Name"
                  placeholder="Name"
                  className="outlined border rounded px-2 mx-1"
                  name="Name"
                  value={customItemName}
                  onChange={(e) => setCustomItemName(e.target.value)}
                  onBlur={() => {}}
                  sx={{ flex: 1, width: "200px" }}
                />

                <Typography sx={{mt: 2}}>Description</Typography>
                <InputBase
                  data-tip
                  data-for="Description"
                  placeholder="Description"
                  className="outlined border rounded px-2 mx-1"
                  name="Description"
                  value={customItemDescription}
                  onChange={(e) => setCustomItemDescription(e.target.value)}
                  onBlur={() => {}}
                  sx={{ flex: 1, width: "300px" }}
                />
              </div>
              </div>
            </div>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            mt="0.5em"
            px="0.5em"
          >
              <ReactTooltip
                id="title"
                effect="solid"
                place="top"
                class="q-color"
              >
                Quantity
              </ReactTooltip>
              <div className="d-flex flex-column mx-2">
                <Typography>Qty.</Typography>
                <InputBase
                  data-tip
                  data-for="title"
                  placeholder="Quantity"
                  className="outlined border rounded px-2 mx-1"
                  name="title"
                  type="number"
                  value={totalQuantity}
                  onChange={(e) => handleQuantity(e.target.value)}
                  onBlur={() => {}}
                  sx={{ flex: 1, width: "50px" }}
                />
              </div>
          </Box>
          <div className="d-flex justify-content-between align-items-center px-2 mt-2">
            <strong className="q-color">Price:</strong>
            <Box display={'flex'} alignItems={'center'}>
                $<InputBase
                    data-tip
                    data-for="price"
                    placeholder="Price"
                    className="outlined border rounded px-2 mx-1"
                    name="Price"
                    type="number"
                    value={customItemPrice}
                    onChange={(e) => {
                        setCustomItemPrice(e.target.value)
                        addToCart()
                    }}
                    sx={{ width: "100px" }}
                />
            </Box>
          </div>
          <div className="d-flex justify-content-between align-items-center px-2 mt-2">
            <strong className="q-color">Finish:</strong>
            <InputBase
                    data-tip
                    data-for="finish"
                    placeholder="Finish"
                    className="outlined border rounded px-2 mx-1"
                    name="Finish"
                    value={customItemFinish}
                    onChange={(e) => setCustomItemFinish(e.target.value)}
                    sx={{ width: "150px" }}
                />
          </div>
          <div className="d-flex justify-content-between align-items-center px-2 mt-2">
            <strong className="q-color">SubTotal:</strong>
            <p className="q-color">${subtotalPrice?.toFixed(2)}</p>
          </div>
          <Box className="text-right px-2 mt-2">
            <Tooltip title="Delete" placement="top">
              <IconButton
                className="cursor-pointer"
                tooltip="Re-ordering is disabled while filtering"
                onClick={(e) => {
                    // dispatch(removeFromCart(props.item));
                }}
              >
                <DeleteOutlinedIcon
                  sx={{ fontSize: "26px", color: colors.redAccent[500] }}
                />
              </IconButton>
            </Tooltip>
          </Box>
          <hr />
        </Box>
      )}
    </>
  );
};
export default CustomQuotationCartItem;
